import type { ISerialize } from '@/objects/ISerialize';
import { DuplicateResult } from './DuplicateResult';

export class DuplicateResultLine implements ISerialize {
    public Duplicates: DuplicateResult[];

    public Original: DuplicateResult | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { Duplicates?: DuplicateResult[]; Original?: DuplicateResult | null }) {
        this.Duplicates = values.Duplicates ?? [];

        this.Original = values.Original ?? null;
    }

    public serialize(): string {
        return (
            '{' +
            `"Duplicates": [ ${this.Duplicates.map((x) => (!x ? null : x?.serialize()))} ]` +
            ',' +
            `"Original": ${!this.Original ? null : this.Original?.serialize()}` +
            '}'
        );
    }

    /**
     * Creates an instance of DuplicateResultLine from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { Duplicates?: DuplicateResult[]; Original?: DuplicateResult | null }): DuplicateResultLine {
        return new DuplicateResultLine(values);
    }

    public static _FromServerJson(json: any): DuplicateResultLine {
        return new DuplicateResultLine({
            Duplicates: json.Duplicates?.map((x: any) => DuplicateResult._FromServerJson(x)),
            Original: json.Original ? DuplicateResult._FromServerJson(json.Original) : null,
        });
    }

    /**
     * Creates an instance of DuplicateResultLine from another instance of DuplicateResultLine.
     * @param other The DuplicateResultLine you want to clone
     * @returns A cloned DuplicateResultLine
     */
    public static FromOther(other: DuplicateResultLine): DuplicateResultLine {
        return DuplicateResultLine._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return DuplicateResultLine.FromOther(this);
    }

    static NAME_OF_CLASS = 'DuplicateResultLine';
}
